(ns app.front.view.workspace.section
  (:require [app.front.entities :as entities]
            [app.front.ui.error-boundary :as eb]
            [app.front.ui.section :as section]
            [core.front.event :refer [<sub]]))

(def visible-sections
  "Defines an allow list of visible sections in the workspace depending on the current viewed state.
  By default all sections are shown."
  {:state.application/pre-submit-payment      #{:application-parties
                                                :application-fees-and-payments}
   :pre-consultation.state/pre-submit-payment #{:application-parties
                                                :application-fees-and-payments}})

(defn workspace-section-visible?
  "Returns true if the given application/execution/etc section is visible in the current view"
  [workspace-child-or-id section-id]
  (if-let [visible-ids (get visible-sections (if (entities/entity-id? workspace-child-or-id)
                                               (<sub [::entities/entity-attr workspace-child-or-id :domain/state])
                                               (:domain/state workspace-child-or-id)))]
    (contains? visible-ids section-id)
    true))

(defn section [fsm-target-or-id section-id state heading initially-collapsed? & children]
  (when (workspace-section-visible? fsm-target-or-id section-id)
    [eb/error-boundary
     (apply
       vector
       (if initially-collapsed? section/initially-collapsed-section section/section)
       (name section-id)
       state
       heading
       children)]))
